import React from "react";
import { Header, Segment } from "semantic-ui-react";

const DecommissionedNotice = () => {
  return (
    <section className="decommissioned-widget">
      <Segment className="decommissioned-widget-content">
        <Header as="h2" className="white-text">
          Flagship Has Been Decommissioned. ⚓
        </Header>
        <p>
          After more than a decade of faithful service, Flagship has officially
          been <strong>permanently docked</strong>. It carried us through
          countless orders, campaigns, and (especially) comments. We&apos;ve had
          plenty of adventures along the way, and we’re grateful for every
          nautical mile.
        </p>
        <p>
          Don&apos;t worry. Flagship will still be here for a while in a read-only
          capacity, but our journey now continues aboard{" "}
          <a
            href="https://mothership.2060digital.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            <strong>Mothership</strong>
          </a>
          , built to take us wherever comes next.
        </p>
        <p>Thanks for sailing with Flagship all these years.</p>
        <p className="decommissioned-widget-farewell">
          Until we meet again on another shore... 💙
        </p>
      </Segment>
    </section>
  );
};

export default DecommissionedNotice;



// WEBPACK FOOTER //
// ./src/components/dashboard/DecommissionedNotice.js